module.exports = __webpack_public_path__ + "static/media/ic-quiz.93bfbfcf.svg";